import {AddSchema} from "mobx-graphlink";
import {AlarmConfigBase, AlarmConfigBase_SchemaProps} from "./@AlarmConfig.js";

export class EngineConfig_SoundAlarm extends AlarmConfigBase {
	//controlBackgroundAudio?: boolean;
	//loop: boolean;
}
AddSchema("EngineConfig_SoundAlarm", {
	properties: {
		...AlarmConfigBase_SchemaProps as any,
		//separate: {type: "boolean"},
		//loop: {type: "boolean"},
	},
});

export class EngineConfig_ShakeAlarm extends AlarmConfigBase {}
AddSchema("EngineConfig_ShakeAlarm", {
	properties: {
		...AlarmConfigBase_SchemaProps as any,
	},
});

export class EngineConfig_LightAlarm extends AlarmConfigBase {}
AddSchema("EngineConfig_LightAlarm", {
	properties: {
		...AlarmConfigBase_SchemaProps as any,
	},
});

export class EngineConfig_ScriptAlarm extends AlarmConfigBase {}
AddSchema("EngineConfig_ScriptAlarm", {
	properties: {
		...AlarmConfigBase_SchemaProps as any,
	},
});

// todo: finish RVP system, then integrate into FBA engine
/*export class EngineConfig_RVPAlarm {
	@O accessor interval = 300;
	@O accessor voicesEnabled = "{}";
	@O accessor minVolume = 1;
	@O accessor maxVolume = 1;
	@O accessor minPitch = .5;
	@O accessor maxPitch = 1.5;
	@O accessor smoothing = 7;
}*/